import React, { useEffect } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { css } from "aphrodite";
import styles from "./styles";
import { notify } from "../../../../Utils";
import {useTranslation} from "react-i18next";
import "../AccessibleLink/AccessibleLink.css";

const RequestLayout = ({
    children,
    error,
    loading,
    overlayLoading = false,
}) => {
    const [t] = useTranslation(["translation"]);
    const isLoading = Boolean(loading);

    useEffect(() => {
        if (error) {
            notify(t("Error, please try again"), "error", 4000);
        }
    }, [error, t]);

    const loadingAnnouncer = (
        <div
            role="status"
            aria-live="polite"
            aria-busy={isLoading}
            aria-label={t("loading")}
        >
            <CircularProgress />
            <span className="visually-hidden">{t("loading")}</span>
        </div>
    );

    return (
        <>
            {error ? (
                <div role="alert" className="visually-hidden">
                    {t("Error, please try again")}
                </div>
            ) : null}
            <>
                {loading && !overlayLoading ? (
                    <div
                        className={css(
                            styles.centerContainer,
                            styles.smallPadding
                        )}
                    >
                        {loadingAnnouncer}
                    </div>
                ) : (
                    <>
                        {children}
                        <Backdrop
                            className={css(styles.backDrop)}
                            open={Boolean(loading && overlayLoading)}
                            aria-hidden={!isLoading || !overlayLoading}
                        >
                            {loadingAnnouncer}
                        </Backdrop>
                    </>
                )}
            </>
        </>
    );
};

export default RequestLayout;
